import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { BiSolidDownArrow } from "react-icons/bi";
import countries from "./countries.json";
import { useCountry } from '../pages/CountryContext'; // Adjust the import path as necessary

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
// In Navbar.jsx
const { selectedCountry = { name: "South Africa", flag: "https://flagcdn.com/w40/za.png" }, 
       setSelectedCountry = () => {} } = useCountry() || {};
  const chevronRef = useRef(null);
  const [flipped, setFlipped] = useState(false);

  const menuItems = [
    { key: "home", label: "About Us", path: "/About" },
    { key: "services", label: "Solutions", path: "/solutions" },
    { key: "reports", label: "Reports", path: "/reports" },
    { key: "communities", label: "Communities", path: "/communities" },
    { key: "resources", label: "Resources", path: "/resources" },
    { key: "gallery", label: "Gallery", path: "/Gallery" },
  ];

  const newsPages = ["/news", "/new1", "/new2", "/new3"];
  useEffect(() => {
    const currentPath = location.pathname;
  
    if (currentPath.startsWith("/solutions")) {
      setActiveTab("services");
    } else if (currentPath.startsWith("/communitypage")) {
      setActiveTab("communities");
    } else {
      const activeMenuItem = menuItems.find((item) => item.path === currentPath);
      setActiveTab(activeMenuItem ? activeMenuItem.key : "");
    }
  }, [location.pathname]);
  
  const handleCountryChange = (country) => {
    // Find the full country data including code
    const fullCountryData = countries.find(c => c.name === country.name);
    setSelectedCountry(fullCountryData);
    setDropdownOpen(false);
    localStorage.setItem('selectedCountry', JSON.stringify(fullCountryData));
  };
  
  const handleNavigation = (direction) => {
    if (newsPages.includes(location.pathname)) {
      navigate("/newsmain");
    } else if (direction === "next") {
      window.history.forward();
    } else {
      window.history.back();
    }
  };

  return (
    <nav className="md:pr-12 md:pl-14 md:py-8 py-1 font-inter font-bold w-full mx-auto bg-transparent z-50 relative flex items-center justify-between md:justify-start md:space-x-2">
      {/* Logo & Chevron */}
      <div className="flex items-center">
  {/* Chevron */}


  {/* Logo (separately clickable if needed) */}
  <a href="/">
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744977692/image_16_csawm3.png"
      alt="Logo"
      className="xl:w-[150px] md:mr-4 md:w-[100px] md:h-[55px] w-[100px] h-[50px] object-contain md:px-0 px-4"
    />
  </a>
  {location.pathname !== "/newsmain" && (
    <div
      className={`relative transition-transform md:mr-5 md:pl-0 pl-3 duration-500 ${
        flipped ? "rotate-[180deg]" : "rotate-0"
      }`}
      onMouseEnter={() => setFlipped(true)}
      onMouseLeave={() => setFlipped(false)}
      ref={chevronRef}
    >
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744118331/Expand_left_oielgn.png"
        alt="Chevron"
        className="cursor-pointer transition-transform hover:scale-110 md:w-[40px] md:h-[40px] w-[20px] h-[20px] object-contain"
        onClick={(e) => {
          e.stopPropagation(); // prevent bubbling
          e.preventDefault(); // prevent default anchor action
          const { left, width } = e.target.getBoundingClientRect();
          const clickPosition = e.clientX - left;
          if (clickPosition < width / 2) {
            handleNavigation("back");
          } else {
            handleNavigation("next");
          }
        }}
      />
    </div>
  )}
</div>


      {/* Desktop Menu */}
      <div className="md:flex hidden space-x-1 ">
        <ul className="flex space-x-2 items-center ">
          {menuItems.map((item) => (
            <li
              key={item.key}
              className={`
                md:rounded-xl transition-all duration-300 text-center 
                text-white xl:bg-[#2E453D] lg:bg-[#2E453D] sm:bg-[#2E453D]
                ${activeTab === item.key
                  ? "border-b-[5px] border-[#FDBD26]"
                  : "border-b-2 border-transparent"}
                ${
                  ["home", "reports", "services", "gallery"].includes(item.key)
                    ? "md:w-[80px] xl:w-[150px] lg:w-[140px]"
                    : "md:w-[100px] xl:w-[160px] lg:w-[150px]"
                }
              `}
            >
              <Link
                to={item.path}
                onClick={() => setActiveTab(item.key)}
                className="block text-[10px] lg:text-[19px] xl:text-[24px] py-1 w-full"
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Country Dropdown */}
      <div className="relative z-50 md:flex hidden  -pl-6 ">
        <button
          className="flex items-center space-x-2 text-sm text-gray-700 p-1 rounded-lg"
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <img
            src={selectedCountry.flag}
            alt={selectedCountry.name}
            className="md:w-14 md:h-10 w-6 h-4"
          />
          <BiSolidDownArrow className="text-white text-sm" />
        </button>
        {dropdownOpen && (
          <div className="absolute right-0 top-12 bg-[#2E453D] shadow-lg rounded-lg mt-1 w-48 z-50">
            <ul className="space-y-2 py-2">
            {countries.map((country, index) => (
  <li
    key={country.code}
    className="flex items-center space-x-2 px-4 py-2 cursor-pointer hover:text-white hover:bg-[#20342d] opacity-0 translate-y-2 animate-slide-down"
    onClick={() => handleCountryChange(country)}
    style={{ animationDelay: `${index * 100}ms` }}
  >
    <img src={country.flag} alt={country.name} className="w-4 h-4" />
    <span className="text-white hover:text-[#D2F34A] text-sm">
      {country.name}
    </span>
  </li>
))}

            </ul>
          </div>
        )}
      </div>

      {/* Hamburger Icon (Mobile Only) */}
      <div
        className="md:hidden flex justify-between items-center gap-2 mr-4 cursor-pointer z-50"
      >
    
        
        <div className="flex flex-col justify-between h-3" onClick={() => setMenuOpen(!menuOpen)}>
          <span className="w-6 h-1 bg-white rounded-sm"></span>
          <span className="w-6 h-1 bg-white rounded-sm"></span>
        </div>
        <h1 className="text-white text-sm" onClick={() => setMenuOpen(!menuOpen)}>Menu</h1>
        <div className="relative z-50  -pl-6 ">
        <button
          className="flex items-center space-x-2 text-sm text-gray-700 p-1 rounded-lg"
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <img
            src={selectedCountry.flag}
            alt={selectedCountry.name}
            className="md:w-14 md:h-10 w-6 h-4"
          />
          <BiSolidDownArrow className="text-white text-sm" />
        </button>
        {dropdownOpen && (
          <div className="absolute right-0 top-12 bg-[#2E453D] shadow-lg rounded-lg mt-1 w-48 z-50">
            <ul className="space-y-2 py-2">
            {countries.map((country, index) => (
  <li
    key={country.code}
    className="flex items-center space-x-2 px-4 py-2 cursor-pointer hover:text-white hover:bg-[#20342d] opacity-0 translate-y-2 animate-slide-down"
    onClick={() => handleCountryChange(country)}
    style={{ animationDelay: `${index * 100}ms` }}
  >
    <img src={country.flag} alt={country.name} className="w-4 h-4" />
    <span className="text-white hover:text-[#D2F34A] text-sm">
      {country.name}
    </span>
  </li>
))}

            </ul>
          </div>
        )}
      </div>
      </div>

      {/* Mobile Nav Menu */}
      {menuOpen && (
        <div className="md:hidden fixed top-0 left-0 w-full h-screen bg-black bg-opacity-60 z-40">
          <ul className="absolute top-16 left-0 w-full bg-white/80 shadow-md flex flex-col items-start space-y-2 py-4 px-4 z-50 backdrop-blur-sm">
            {menuItems.map((item, index) => (
              <Link
                key={item.key}
                to={item.path}
                onClick={() => {
                  setActiveTab(item.key);
                  setMenuOpen(false);
                }}
                className={`w-full block rounded py-3 px-2 cursor-pointer 
                  transition-all duration-500 opacity-0 translate-y-2 
                  ${activeTab === item.key
                    ? "bg-[#2E453D] text-white"
                    : "bg-white/60 text-black hover:bg-gray-200"}
                `}
                style={{
                  animation: `fadeIn 0.5s ease forwards`,
                  animationDelay: `${index * 150}ms`,
                }}
              >
                {item.label}
              </Link>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
